"use client";

import type React from "react";

import { FormattedHtmlContent } from "./formatted-html-content";
import { cn } from "./utils";
import { getHighlightStyle } from "./utils/highlight-styles";
import type { Element } from "./utils/type";

interface PreviewElementItemProps {
  element: Element;
  index: number;
  isSelected: boolean;
  isHovered: boolean;
  hasCoordinates: boolean;
  onClick?: (e: React.MouseEvent) => void;
  onMouseEnter?: (e: React.MouseEvent) => void;
  onMouseLeave?: (e: React.MouseEvent) => void;
}
/**
 * 개별 Element를 렌더링하는 컴포넌트
 */
export function PreviewElementItem({
  element,
  index,
  isSelected,
  isHovered,
  hasCoordinates,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: PreviewElementItemProps) {
  // 현재는 element.category를 하이라이트 키로 사용
  const highlightStyle = getHighlightStyle(element.category);

  return (
    <div
      className={cn(
        "relative mb-4 w-full rounded-sm p-2 pt-4 transition-colors",
        hasCoordinates ? "cursor-pointer" : "cursor-default",
        isHovered && highlightStyle.containerHover,
        isSelected && highlightStyle.containerSelected,
      )}
      key={`element-${index}`}
      onClick={hasCoordinates ? onClick : undefined}
      onMouseEnter={hasCoordinates ? onMouseEnter : undefined}
      onMouseLeave={hasCoordinates ? onMouseLeave : undefined}
    >
      <div
        className={cn(
          "detail absolute -top-2 left-[-10] rounded-sm border px-1.5 capitalize",
          "border-transparent bg-transparent text-muted-foreground",
          isHovered && highlightStyle.labelHover,
          isSelected && highlightStyle.labelSelected,
        )}
      >
        {index + 1} - {element.category}
        {element.sub_category ? ` / ${element.sub_category}` : ""}
      </div>
      <div className="flex flex-col overflow-auto">
        <div className="mb-1 whitespace-pre-line">
          <FormattedHtmlContent element={element} index={index} />
        </div>
      </div>
    </div>
  );
}
